import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './create-new-profiles-for-custom-collection-confirmation-modal.scss';

applyTranslations(
  require('./create-new-profiles-for-custom-collection-confirmation-modal.i18n.json')
);

const CreateNewProfilesForCustomCollectionConfirmationModal = (): JSX.Element => (
  <div className="create-new-profiles-for-custom-collection-confirmation-modal">
    {__t('create_new_profiles_for_custom_collection_confirmation_modal.text')}
  </div>
);

export default CreateNewProfilesForCustomCollectionConfirmationModal;
